import { render, staticRenderFns } from "./SalesInvoiceRows.vue?vue&type=template&id=b9c4e054&scoped=true"
import script from "./SalesInvoiceRows.vue?vue&type=script&lang=ts"
export * from "./SalesInvoiceRows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c4e054",
  null
  
)

export default component.exports